module.exports = __webpack_public_path__ + "img/zeigling.2759d586.jpg";